var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5787 11.7975L7.00056 1.97329C6.96769 1.94742 6.92819 1.93134 6.8866 1.9269C6.84501 1.92246 6.803 1.92984 6.76541 1.9482C6.72783 1.96656 6.69618 1.99514 6.67411 2.03068C6.65203 2.06621 6.64043 2.10725 6.64063 2.14908V4.30588C6.64063 4.4426 6.7048 4.57374 6.81083 4.65745L16.8555 12.5006L6.81083 20.3438C6.70201 20.4275 6.64063 20.5587 6.64063 20.6954V22.8522C6.64063 23.0391 6.85547 23.1424 7.00056 23.028L19.5787 13.2038C19.6856 13.1204 19.7721 13.0137 19.8316 12.8919C19.891 12.77 19.922 12.6362 19.922 12.5006C19.922 12.3651 19.891 12.2313 19.8316 12.1094C19.7721 11.9876 19.6856 11.8809 19.5787 11.7975Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.1d524a91.svg";
export { ForwardRef as ReactComponent };